const errorIconDataUri =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><path fill='%23E40A1A' fill-rule='evenodd' clip-rule='evenodd' d='M0 6.79586C0 3.00959 3.00959 0 6.79586 0C10.5821 0 13.5917 3.00959 13.5917 6.79586C13.5917 10.5821 10.5821 13.5917 6.79586 13.5917C3.00959 13.5917 0 10.5821 0 6.79586ZM0.970837 6.79586C0.970837 9.99962 3.5921 12.6209 6.79586 12.6209C9.99962 12.6209 12.6209 9.99962 12.6209 6.79586C12.6209 3.5921 9.99962 0.970837 6.79586 0.970837C3.5921 0.970837 0.970837 3.5921 0.970837 6.79586ZM6.79586 7.57253L9.41712 10.1938L10.1938 9.41712L7.57253 6.79586L10.1938 4.1746L9.41712 3.39793L6.79586 6.01919L4.1746 3.39793L3.39793 4.1746L6.01919 6.79586L3.39793 9.41712L4.1746 10.1938L6.79586 7.57253Z'/></svg>";

export const MuiFormHelperText = {
  styleOverrides: {
    root: {
      position: 'absolute',
      top: '100%',
      marginLeft: 2,
      fontSize: '1.4rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.4rem',

      '&.Mui-error': {
        color: '#A3001E',
      },
      '&.Mui-error::before': {
        content: '""',
        display: 'inline-block',
        width: '1.4rem',
        height: '1.4rem',
        backgroundImage: `url("${errorIconDataUri}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      },
    },
  },
};
